import { defineComponent as c, inject as u, h as r } from "vue";
import { dropdownMenuInjectionKey as b, dropdownInjectionKey as f } from "./ghl-ui.es997.js";
import { render as l } from "./ghl-ui.es985.js";
const y = c({
  name: "DropdownGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      showIconRef: n,
      hasSubmenuRef: o
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = u(b), {
      renderLabelRef: i,
      labelFieldRef: p,
      nodePropsRef: d,
      renderOptionRef: t
    } = (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      u(f)
    );
    return {
      labelField: p,
      showIcon: n,
      hasSubmenu: o,
      renderLabel: i,
      nodeProps: d,
      renderOption: t
    };
  },
  render() {
    var n;
    const {
      clsPrefix: o,
      hasSubmenu: i,
      showIcon: p,
      nodeProps: d,
      renderLabel: t,
      renderOption: s
    } = this, {
      rawNode: e
    } = this.tmNode, a = r("div", Object.assign({
      class: `${o}-dropdown-option`
    }, d == null ? void 0 : d(e)), r("div", {
      class: `${o}-dropdown-option-body ${o}-dropdown-option-body--group`
    }, r("div", {
      "data-dropdown-option": !0,
      class: [`${o}-dropdown-option-body__prefix`, p && `${o}-dropdown-option-body__prefix--show-icon`]
    }, l(e.icon)), r("div", {
      class: `${o}-dropdown-option-body__label`,
      "data-dropdown-option": !0
    }, t ? t(e) : l((n = e.title) !== null && n !== void 0 ? n : e[this.labelField])), r("div", {
      class: [`${o}-dropdown-option-body__suffix`, i && `${o}-dropdown-option-body__suffix--has-submenu`],
      "data-dropdown-option": !0
    })));
    return s ? s({
      node: a,
      option: e
    }) : a;
  }
});
export {
  y as default
};
